'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolvedAttachmentEntriesForThreadFromProps = undefined;

var _reselect = require('reselect');

var _set = require('transmute/set');

var _set2 = _interopRequireDefault(_set);

var _immutable = require('immutable');

var _getEntry = require('conversations-internal-schema/indexed-async-data/operators/getEntry');

var _fileAttachmentIdsForThreadFromProps = require('./fileAttachmentIdsForThreadFromProps');

var _getResolvedAttachments = require('./getResolvedAttachments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resolvedAttachmentEntriesForThreadFromProps = exports.resolvedAttachmentEntriesForThreadFromProps = (0, _reselect.createSelector)([_getResolvedAttachments.getResolvedAttachments, _fileAttachmentIdsForThreadFromProps.fileAttachmentIdsForThreadFromProps], function (attachmentsState, attachmentIds) {
  return attachmentIds.reduce(function (resolvedAttachmentEntries, attachmentId) {
    var entry = (0, _getEntry.getEntry)(attachmentId, attachmentsState);

    if (!entry) {
      return resolvedAttachmentEntries;
    }

    return (0, _set2.default)(attachmentId, entry, resolvedAttachmentEntries);
  }, (0, _immutable.Map)());
});


//////////////////
// WEBPACK FOOTER
// ./js/resolved-attachments/selectors/resolvedAttachmentEntriesForThreadFromProps.js
// module id = 600
// module chunks = 2 3